import React, { useState } from 'react'
import { UserIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import LoginModal from '../login-modal'
import spektrixAuth from '@lib/spektrix/auth'

const UserMenu = ({ authState }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  const handleLogout = async () => {
    await spektrixAuth.logout()
    setIsDropdownOpen(false)
  }

  const handleLoginSuccess = () => {
    setIsLoginModalOpen(false)
  }

  if (authState.loading) {
    return (
      <div className="flex items-center">
        <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div>
      </div>
    )
  }

  if (authState.authenticated && authState.user) {
    // User is logged in - show user menu
    const userName = authState.user.firstName || authState.user.name || 'User'
    
    return (
      <div className="relative">
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          <UserIcon className="w-5 h-5" />
          <span className="hidden sm:inline">{userName}</span>
          <ChevronDownIcon className="w-4 h-4" />
        </button>

        {isDropdownOpen && (
          <>
            {/* Backdrop */}
            <div 
              className="fixed inset-0 z-10" 
              onClick={() => setIsDropdownOpen(false)}
            />
            
            {/* Dropdown menu */}
            <div className="absolute right-0 z-20 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700">
              <div className="py-1">
                <div className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                  Signed in as <span className="font-medium">{userName}</span>
                </div>
                <a
                  href="/my-account"
                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  My Account
                </a>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    )
  }

  // User is not logged in - show login button
  return (
    <>
      <button
        onClick={() => setIsLoginModalOpen(true)}
        className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
      >
        <UserIcon className="w-5 h-5" />
        <span className="hidden sm:inline">Sign In</span>
      </button>

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  )
}

export default UserMenu